<script setup>
import { onMounted, ref, computed, nextTick } from 'vue';
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
// import Swal from 'sweetalert2';
import store from '../../state/store';
// import Swal from 'sweetalert2';
// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";
// import { useToast } from "vue-toastification";
// Import the CSS or use your own!
// import "vue-toastification/dist/index.css";
import '@jobinsjp/vue3-datatable/dist/style.css';
import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
import moment from 'moment';

import { createToaster } from "@meforma/vue-toaster";
const toaster = createToaster({   
  position: 'top' 
});

// const toast = useToast();

const title = ref('Add Tracking');

const items = ref([
  {
    text: "Home",
  },
    {
    text: "Delivery",
  },
  {
    text: "Add Tracking",
    active: true,
  }
]);

const notice_of_violation_number = ref([]);
const tracking_number = ref([]);

const allCouriers = computed(() => store.state.courier.dropdownCouriers);
const allTrackingLogs = computed(() => store.state.courier.trackingLogs);
const loading = computed(() => store.state.globals.loading);

// const humanfriendlyConfig = ref({
//   dateFormat: "F j, Y",
// });

// const dateValue = ref(null);

const inputNov = ref(null);
const inputTracking = ref(null);

const changeNovFocus = (index) => {
  inputTracking.value[index].focus();
}

const changeNovFocusWithTimeout = (index) => {
  setTimeout(() => {
    inputTracking.value[index].focus();
  }, 0)
}

const changeTrackingFocus = (index, name) => {
  submit(index, name);
  inputNov.value[index].focus();
  notice_of_violation_number.value[index] = null;
}

const changeTrackingFocusWithTimeout = (index, name) => {
  setTimeout(() => {
    submit(index, name);
    inputNov.value[index].focus();
    notice_of_violation_number.value[index] = null;
  }, 200)
}

const submit = async (index, name) => {
  if (!notice_of_violation_number.value[index] && !tracking_number.value[index]) {
    toaster.error("Error: Please fill up required fields!")
    return;
  }

  try {
    await store.dispatch('courier/addTracking', {
      tracking_courier_id: allCouriers.value[index].id,
      notice_of_violation_number: notice_of_violation_number.value[index],
      tracking_number: tracking_number.value[index],
      index,
      name
    });

    notice_of_violation_number.value[index] = null;
    tracking_number.value[index] = null;
    inputNov.value[index].focus();
  } catch (err) {
    console.log(err);
    notice_of_violation_number.value[index] = null;
    tracking_number.value[index] = null;
    inputNov.value[index].focus();
  }
  getTrackingLogs()
}

const onTabChange = async (index) => {
  await nextTick();
  inputNov.value[index].focus();
}

const getTrackingLogs = async () => {
    await store.dispatch('courier/getTrackingLogs', {
        limit: 10,
    });
}

onMounted(async () => {
  await store.dispatch('courier/getCouriersDropdown');

  if (inputNov.value && inputNov.value.length) {
    inputNov.value[0].focus();
  }
})
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <div class="row">
        <b-overlay :show="loading">
          <div class="card">
            <div class="card-body">
              <div class="m-4">
                <img src="@/assets/images/qpax/tracking-logo.png" width="150" />
                <h1 class="fs-4 text m-2">Add Tracking</h1>
              </div>
              <div class="m-2">
                  <b-tabs v-if="allCouriers && allCouriers.length" tag="ul" class="nav-primary nav-tabs-custom" justified content-class="mt-3">
                    <b-tab @click="onTabChange(index)" v-for="(courier, index) in allCouriers" :key="courier.id" :title="courier.name">
                      <div class="m-5">
                        <img v-if="courier.logo" :src="courier.logo" :alt="courier.name" width="150" />
                      </div>
                      <div class="row">
                        <div class="col-md-12 col-lg-6">
                          <div class="mb-3">
                            <label :for="`id-${courier.name}-nov`" class="form-label required">NOV Number</label>
                            <input autofocus autocomplete="off" v-on:paste="changeNovFocusWithTimeout(index)" @keydown.enter="changeNovFocus(index)" ref="inputNov" :id="`id-${courier.name}-nov`" type="text" v-model="notice_of_violation_number[index]" class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-12 col-lg-6">
                          <div class="mb-3">
                            <label :for="`id-${courier.name}-barcode`" class="form-label required">Barcode Tracking</label>
                            <input autocomplete="off" v-on:paste="changeTrackingFocusWithTimeout(index, courier.name)" @keydown.enter="changeTrackingFocus(index, courier.name)" ref="inputTracking" :id="`id-${courier.name}-barcode`" type="text" v-model="tracking_number[index]" class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-12 col-lg-6">
                          <div class="mb-3">
                            <button @click="submit(index, courier.name)" class="btn btn-primary bg-gradient waves-effect waves-light fs-5 text">
                              <i class="mdi mdi-content-save mr-2 align-middle"></i>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                  </b-tabs>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title mb-0">Activity Logs</h4>
            </div>
            <div class="card-body">
              <data-table
                  :rows="allTrackingLogs"
                  striped
                  filter
                  hoverable
                  sortable
                  @loadData="getTrackingLogs"
              >
                  <template #thead>
                      <table-head>NOV Number</table-head>
                      <table-head>Barcode Tracking</table-head>
                      <table-head>Batch No.</table-head>
                      <table-head>User</table-head>
                      <table-head>Courier</table-head>
                      <table-head>Status</table-head>
                      <table-head></table-head>
                  </template>
                  <template #tbody="{row}">
                      <table-body v-text="row.notice_of_violation_number ?? 'N/A'" />
                      <table-body v-text="row.tracking_number ?? 'N/A'" />
                      <table-body v-text="row.batch ? row.batch.batch_number : 'N/A'" />
                      <table-body v-text="row.user.name" />
                      <table-body v-text="row.tracking_courier ? row.tracking_courier.name : 'N/A'" />
                      <table-body :class="row.has_failed ? 'text-danger' : 'text-success'">
                        {{ row.has_failed ? 'Error' : 'Success' }}
                        <span class="text-muted" v-if="row.has_failed"><br> {{ row.message }} </span>
                      </table-body>
                      <table-body v-text="moment(row.created_at).fromNow()" />
                  </template>

                  <template #empty>
                  <TableBodyCell colspan="10">
                      No Tracking Logs found!
                  </TableBodyCell>
                </template>
              </data-table>
            </div>
          </div>
        </b-overlay>
    </div>
  </Layout>
</template>